import { render, staticRenderFns } from "./CouponCode.vue?vue&type=template&id=50618386&scoped=true&"
import script from "./CouponCode.vue?vue&type=script&lang=ts&"
export * from "./CouponCode.vue?vue&type=script&lang=ts&"
import style0 from "./CouponCode.vue?vue&type=style&index=0&id=50618386&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50618386",
  null
  
)

export default component.exports